<template>
    <main>

        <div class="row">

            <div class="col-sm-12">
                <form-create v-if="dialogCreate" :avaliacao-questao-id="avaliacaoQuestaoId" @on-saved="onSaved()" @on-back="hideAll()" />
            </div>

            <div class="col-sm-12">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Tag</th>
                                <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                <td>{{ item.tagJobs.nome }}</td>
                                <td class="text-center">
                                    <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Remover" @click="openRemove(item)">
                                        <i class="fa fa-trash-o"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'

    export default {
        name: 'avaliacaoquestaotagjobs',
        mixins: [base],
        props: { avaliacaoQuestaoId: Number },
        components: { formCreate },
        data() {
            return {

                resources: {
                    filter: 'avaliacaoquestaotagjobs',
                    remove: 'avaliacaoquestaotagjobs'
                },

                dialogCreate: true,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {

            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },

            hideAll: function () {
                this.dialogCreate = false;
                setTimeout(() => {
                    this.dialogCreate = true;
                }, 1000)
            },

            openRemove: function (model) {
                this.executeRemove(model);
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeLoad: function () {
                this.showLoading();
                this.filter.avaliacaoQuestaoId = this.avaliacaoQuestaoId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeLoad();
        }

    };
</script>